// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Follow ${i.handle} on X`
};

const de_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Folge ${i.handle} auf X`
};

const es_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Seguir a ${i.handle} en X`
};

const fr_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Suivre ${i.handle} sur X`
};

const fi_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Seuraa käyttäjää ${i.handle} X:ssä`
};

const hi_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `X पर ${i.handle} को फॉलो करें`
};

const ja_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Xで${i.handle}をフォロー`
};

const nl_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Volg ${i.handle} op X`
};

const pt_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Seguir ${i.handle} no X`
};

const ro_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Urmărește ${i.handle} pe X`
};

const th_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `ติดตาม ${i.handle} บน X`
};

const ur_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.handle} کو ایکس پر فالو کریں`
};

const zh_hant1_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `在 X 上追蹤 ${i.handle}`
};

const da_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Følg ${i.handle} på X`
};

const it_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Segui ${i.handle} su X`
};

const vn_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Theo dõi ${i.handle} trên X`
};

const ko_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `X에서 ${i.handle} 팔로우하기`
};

const tr_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `X'te ${i.handle} hesabını takip et`
};

const lv_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Sekojiet ${i.handle} X`
};

const ar_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `تابع ${i.handle} على X`
};

const bs_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Pratite ${i.handle} na X`
};

const sl_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Sledite ${i.handle} na X`
};

const id_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Ikuti ${i.handle} di X`
};

const sv_widget_actions_follow_on_x = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Följ ${i.handle} på X`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ handle: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_actions_follow_on_x = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_actions_follow_on_x(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_actions_follow_on_x", locale)
	if (locale === "en") return en_widget_actions_follow_on_x(inputs)
	if (locale === "de") return de_widget_actions_follow_on_x(inputs)
	if (locale === "es") return es_widget_actions_follow_on_x(inputs)
	if (locale === "fr") return fr_widget_actions_follow_on_x(inputs)
	if (locale === "fi") return fi_widget_actions_follow_on_x(inputs)
	if (locale === "hi") return hi_widget_actions_follow_on_x(inputs)
	if (locale === "ja") return ja_widget_actions_follow_on_x(inputs)
	if (locale === "nl") return nl_widget_actions_follow_on_x(inputs)
	if (locale === "pt") return pt_widget_actions_follow_on_x(inputs)
	if (locale === "ro") return ro_widget_actions_follow_on_x(inputs)
	if (locale === "th") return th_widget_actions_follow_on_x(inputs)
	if (locale === "ur") return ur_widget_actions_follow_on_x(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_actions_follow_on_x(inputs)
	if (locale === "da") return da_widget_actions_follow_on_x(inputs)
	if (locale === "it") return it_widget_actions_follow_on_x(inputs)
	if (locale === "vn") return vn_widget_actions_follow_on_x(inputs)
	if (locale === "ko") return ko_widget_actions_follow_on_x(inputs)
	if (locale === "tr") return tr_widget_actions_follow_on_x(inputs)
	if (locale === "lv") return lv_widget_actions_follow_on_x(inputs)
	if (locale === "ar") return ar_widget_actions_follow_on_x(inputs)
	if (locale === "bs") return bs_widget_actions_follow_on_x(inputs)
	if (locale === "sl") return sl_widget_actions_follow_on_x(inputs)
	if (locale === "id") return id_widget_actions_follow_on_x(inputs)
	if (locale === "sv") return sv_widget_actions_follow_on_x(inputs)
	return "widget_actions_follow_on_x"
};